export default __webpack_public_path__ + "static/media/clothesLogo.7295c46c.svg";